module.exports = __webpack_public_path__ + "img/1561037463.d446b32b.jpg";